module.exports = __webpack_public_path__ + "static/media/work4.dfaed66a.jpg";